import { render, staticRenderFns } from "./work-view-classifications.vue?vue&type=template&id=d1734c78&scoped=true"
import script from "./work-view-classifications.vue?vue&type=script&lang=js"
export * from "./work-view-classifications.vue?vue&type=script&lang=js"
import style0 from "./work-view-classifications.vue?vue&type=style&index=0&id=d1734c78&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1734c78",
  null
  
)

export default component.exports